import React from "react";
import ReactTooltip from "react-tooltip";
import { Button, Icon, IconButton } from "../../_components";

export function TimelineListItem({ timeline, onToggle, onEdit, onDelete }) {
  const handleDelete = (ev) => {
    if (onDelete) {
      onDelete(timeline._id);
    }
  };
  const handleToggle = (ev) => {
    if (onToggle) {
      onToggle(timeline._id);
    }
  };
  const handleEdit = (ev) => {
    if (onEdit) {
      onEdit(timeline._id);
    }
  };
  // console.log('TIMELINE LIST ITEM', timeline);
  const activeIcon = "fas fa-eye fa-fw";
  const inactiveIcon = "fas fa-eye-slash fa-fw";
  return (
    <li className="chronos-timelinelist-item chronos-list-item">
      <span className="chronos-timelinelist-item-title">{timeline.title}</span>
      <span className="chronos-timelinelist-item-options">
        <IconButton
          data-tip="Toggle Visibility"
          type="button"
          color={timeline.active ? "success" : "secondary"}
          onClick={handleToggle}
          icon={timeline.active ? activeIcon : inactiveIcon}
          size="xs"
        ></IconButton>
        <IconButton
          data-tip="Edit Timeline"
          type="button"
          color="primary"
          onClick={handleEdit}
          icon="fas fa-pencil fa-fw"
          size="xs"
        ></IconButton>
        <IconButton
          data-tip="Delete Timeline"
          type="button"
          color="danger"
          onClick={handleDelete}
          icon="fas fa-trash fa-fw"
          size="xs"
        ></IconButton>
      </span>
      <ReactTooltip className="chronos-form-button-tooltip" effect="solid" />
    </li>
  );
}
